
const digest = 'e50de823936cad4bf88c05d01c2c368dbe34bc154d5e232bd9472d63e4a41d1f';
const classes = {"tableWrapper":"_tableWrapper_bqtx0_1","row":"_row_bqtx0_5","cell":"_cell_bqtx0_13","nestedRow":"_nestedRow_bqtx0_22","dataWrapper":"_dataWrapper_bqtx0_28"};
const css = `._tableWrapper_bqtx0_1 {
  width: 100%;
  border-collapse: collapse;
}
._tableWrapper_bqtx0_1 ._row_bqtx0_5 {
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
}
._tableWrapper_bqtx0_1 ._row_bqtx0_5:nth-child(odd) {
  background: #f2f4f7;
}
._tableWrapper_bqtx0_1 ._row_bqtx0_5 ._cell_bqtx0_13 {
  font-family: Rubik;
  font-size: 14px;
  display: flex;
  justify-content: flex-end;
}
._tableWrapper_bqtx0_1 ._row_bqtx0_5 ._cell_bqtx0_13:nth-child(1) {
  justify-content: flex-start;
}
._tableWrapper_bqtx0_1 ._nestedRow_bqtx0_22 {
  display: flex;
  flex-direction: column;
  padding: 12px 0 12px 24px;
}

._dataWrapper_bqtx0_28 {
  display: flex;
  justify-content: space-between;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  